import { render, staticRenderFns } from "./CompanyPoliciesandRegulations.vue?vue&type=template&id=3e68c247&scoped=true&"
import script from "./CompanyPoliciesandRegulations.vue?vue&type=script&lang=js&"
export * from "./CompanyPoliciesandRegulations.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPoliciesandRegulations.vue?vue&type=style&index=0&id=3e68c247&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e68c247",
  null
  
)

export default component.exports